import { memo } from 'react';

import { type PublicClip } from '@air/api';
import { type Clip } from '@air/api/types';
import { formatDuration } from '@air/utilities';
import { ClipUtils, isPdfRenderedExtension } from '@air/utils-clips';

export type GalleryAssetShortInfoProps = {
  clip: Clip | PublicClip;
};

export const GalleryAssetShortInfo = memo(({ clip }: GalleryAssetShortInfoProps) => {
  const isGifExtension = clip.ext === 'gif';
  const isPdfExtension = isPdfRenderedExtension(clip.ext);
  const time = formatDuration(clip.duration ?? 0);
  const transcoded = ClipUtils.isTranscoded(clip.status);
  const videoTime = clip.type === 'video' && transcoded && time;

  const value = isGifExtension ? 'GIF' : isPdfExtension ? clip.ext.toUpperCase() : videoTime;

  if (!value) {
    return null;
  }

  return (
    <div className="absolute right-3 bottom-3 flex h-4 items-center rounded-2 bg-black/80 px-1 font-medium text-10 text-white uppercase tabular-nums opacity-100 group-data-[hovering=true]/gallery-selectable-card:opacity-0">
      {value}
    </div>
  );
});

GalleryAssetShortInfo.displayName = 'GalleryAssetShortInfo';
